"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.concat.js");

var _slicedToArray2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/slicedToArray.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _index = _interopRequireDefault(require("@/components/ReportNav/index.vue"));

var _common = require("@/api/common");

var _report = require("@/api/report");

var _compare = _interopRequireDefault(require("@/config/compare"));

var _LineChart = _interopRequireDefault(require("@/components/Chart/LineChart.vue"));

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Compare',
  components: {
    ReportNav: _index.default,
    LineChart: _LineChart.default
  },
  data: function data() {
    return {
      compare: _compare.default,
      scrollWidth: '100%',
      projectId: '',
      reportId: '',
      letterArr: ['A', 'B', 'C', 'D', 'E'],
      cardArr: [],
      tableCardArr: [],
      reportList: [],
      reportMap: {},
      reportInfoJson: {},
      compareData: null
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['reportDevice'])),
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var reportListRes, i;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.projectId = _this.$route.params.projectId;
              _this.reportId = _this.$route.params.reportId + '';
              _context.next = 4;
              return (0, _report.informNormalList)({
                page: 0,
                pagesize: 600,
                game_id: _this.projectId
              });

            case 4:
              reportListRes = _context.sent;
              _this.reportList = reportListRes.data.data.list;

              _this.reportList.map(function (one) {
                _this.reportMap[one.inform_id] = one;
              });

              for (i = 0; i < _this.reportList.length; i++) {
                _this.reportInfoJson[_this.reportList[i].inform_id] = {
                  s_list: []
                };
              }

              _context.next = 10;
              return _this.loadReportPageFile(_this.reportId, 's_list');

            case 10:
              // const informRes = await informJSONInfo({
              //   inform_id: this.reportId,
              //   key: 's_list'
              // })
              // const fileRes = await getFile(informRes.data.data)
              _this.cardArr.push({
                reportId: _this.reportId,
                section: 0
              });

              _this.cardArr.push({
                reportId: _this.reportId,
                section: 0
              }); // this.cardArr.push({ reportId: this.reportId, section: 0 })
              // this.cardArr.push({ reportId: this.reportId, section: 0 })
              // this.reportInfoJson[this.reportId].s_list = fileRes.data


              _this.scrollWidth = Math.min(_this.cardArr.length + 1, _this.letterArr.length) * 440 + 'px';

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    addReport: function addReport() {
      this.cardArr.push({
        reportId: this.reportId,
        section: 0
      });
      this.scrollWidth = Math.min(this.cardArr.length + 1, this.letterArr.length) * 440 + 'px';
    },
    delReport: function delReport(index) {
      this.cardArr.splice(index, 1);
    },
    changeReport: function changeReport(index) {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var reportId, informRes, fileRes;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('changeReport', index);
                reportId = _this2.cardArr[index].reportId;

                if (!(_this2.reportInfoJson[reportId] && _this2.reportInfoJson[reportId].s_list.length)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", false);

              case 4:
                _context2.next = 6;
                return (0, _report.informJSONInfo)({
                  inform_id: reportId,
                  key: 's_list'
                });

              case 6:
                informRes = _context2.sent;
                _context2.next = 9;
                return (0, _common.getFile)(informRes.data.data);

              case 9:
                fileRes = _context2.sent;

                if (!_this2.reportInfoJson[reportId]) {
                  _this2.reportInfoJson[reportId] = {};
                }

                _this2.reportInfoJson[reportId].s_list = fileRes.data;

                _this2.$set(_this2.cardArr[index], 'reportId', reportId);

                _this2.$set(_this2.cardArr[index], 'section', -1);

                _this2.$set(_this2.cardArr[index], 'section', 0);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    compareHandle: function compareHandle() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data, i, one, oneData, j, chartOne, _j, _chartOne, _i, tableData;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('compareHandle');
                data = {
                  chart: [],
                  table: []
                };

                if (!(_this3.compare.chart && _this3.compare.chart.length)) {
                  _context3.next = 31;
                  break;
                }

                i = 0;

              case 4:
                if (!(i < _this3.compare.chart.length)) {
                  _context3.next = 31;
                  break;
                }

                one = _this3.compare.chart[i];
                oneData = {
                  title: one.title,
                  line: [],
                  bar: []
                };

                if (!(one.chart && one.chart.length)) {
                  _context3.next = 17;
                  break;
                }

                j = 0;

              case 9:
                if (!(j < one.chart.length)) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 12;
                return _this3.getReportLineData(one.chart[j].title, one.chart[j].pos);

              case 12:
                chartOne = _context3.sent;
                // 获取line 的 数据
                oneData.line.push(chartOne);

              case 14:
                j++;
                _context3.next = 9;
                break;

              case 17:
                if (!(one.histogram && one.histogram.length)) {
                  _context3.next = 27;
                  break;
                }

                _j = 0;

              case 19:
                if (!(_j < one.histogram.length)) {
                  _context3.next = 27;
                  break;
                }

                _context3.next = 22;
                return _this3.getReportBarData(one.histogram[_j].title, one.histogram[_j].pos);

              case 22:
                _chartOne = _context3.sent;
                // 获取line 的 数据
                oneData.bar.push(_chartOne);

              case 24:
                _j++;
                _context3.next = 19;
                break;

              case 27:
                data.chart.push(oneData);

              case 28:
                i++;
                _context3.next = 4;
                break;

              case 31:
                if (!(_this3.compare.table && _this3.compare.table.length)) {
                  _context3.next = 43;
                  break;
                }

                _i = 0;

              case 33:
                if (!(_i < _this3.compare.table.length)) {
                  _context3.next = 42;
                  break;
                }

                if (!(_this3.compare.table[_i].pos === 's_list')) {
                  _context3.next = 39;
                  break;
                }

                _context3.next = 37;
                return _this3.getReportTableSList();

              case 37:
                tableData = _context3.sent;
                data.table.push(tableData);

              case 39:
                _i++;
                _context3.next = 33;
                break;

              case 42:
                console.log(data.table);

              case 43:
                _this3.compareData = data;
                console.log('compareData', data);
                setTimeout(function () {
                  // console.log(this.$refs.chart)
                  _this3.$refs.chart.map(function (one) {
                    one.resize();
                  });
                }, 16);

              case 46:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getReportLineData: function getReportLineData(title, prop) {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _prop$split, _prop$split2, pageKey, name, id, seriesdata, totalFrame, intervalFrame, legenddata, i, card, chartData, prefix, sectionData, sliceStart, sliceEnd;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _prop$split = prop.split('.'), _prop$split2 = (0, _slicedToArray2.default)(_prop$split, 3), pageKey = _prop$split2[0], name = _prop$split2[1], id = _prop$split2[2];
                seriesdata = [];
                totalFrame = 0;
                intervalFrame = 1;
                legenddata = [];
                i = 0;

              case 6:
                if (!(i < _this4.cardArr.length)) {
                  _context4.next = 26;
                  break;
                }

                card = _this4.cardArr[i];
                _context4.next = 10;
                return _this4.getReportPropLineData(card.reportId, pageKey, name, id);

              case 10:
                chartData = _context4.sent;

                if (!(chartData === false)) {
                  _context4.next = 13;
                  break;
                }

                throw new Error('加载数据失败');

              case 13:
                prefix = '报告' + _this4.letterArr[i]; // 报告A

                _context4.next = 16;
                return _this4.loadReportPageFileJson(card.reportId, 's_list');

              case 16:
                sectionData = _context4.sent;

                // debugger
                if (chartData.data.intervalFrame) {
                  console.log('compare intervalFrame', chartData.data.intervalFrame);

                  if (intervalFrame > 1) {
                    intervalFrame = Math.min(intervalFrame, chartData.data.intervalFrame);
                  } else {
                    intervalFrame = chartData.data.intervalFrame;
                  }
                }

                sliceStart = Math.floor(sectionData[card.section].startFrame / intervalFrame);
                sliceEnd = Math.ceil(sectionData[card.section].endFrame / intervalFrame);
                totalFrame = (sliceEnd - sliceStart) * intervalFrame | 0; // debugger

                legenddata.push(prefix + ' ' + chartData.data.legenddata[0]);
                seriesdata.push({
                  name: prefix + ' ' + chartData.data.seriesdata[0].name,
                  type: chartData.data.seriesdata[0].type,
                  showSymbol: chartData.data.seriesdata[0].showSymbol,
                  // areaStyle: {},
                  data: chartData.data.seriesdata[0].data.slice(sliceStart, sliceEnd)
                });

              case 23:
                i++;
                _context4.next = 6;
                break;

              case 26:
                return _context4.abrupt("return", {
                  title: title,
                  id: id,
                  data: {
                    title: {
                      text: title
                    },
                    intervalFrame: intervalFrame,
                    legenddata: legenddata,
                    totalFrame: totalFrame,
                    seriesdata: seriesdata
                  }
                });

              case 27:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getReportBarData: function getReportBarData(title, prop) {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _prop$split3, _prop$split4, pageKey, name, id, xAxisData, data, i, card, chartData, prefix;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _prop$split3 = prop.split('.'), _prop$split4 = (0, _slicedToArray2.default)(_prop$split3, 3), pageKey = _prop$split4[0], name = _prop$split4[1], id = _prop$split4[2];
                xAxisData = [];
                data = [];
                _this5.tableCardArr = [];
                i = 0;

              case 5:
                if (!(i < _this5.cardArr.length)) {
                  _context5.next = 19;
                  break;
                }

                card = _this5.cardArr[i];
                _context5.next = 9;
                return _this5.getReportPropData(card.reportId, pageKey, name, id, card.section);

              case 9:
                chartData = _context5.sent;

                if (!(chartData === false || chartData === undefined)) {
                  _context5.next = 12;
                  break;
                }

                throw new Error('加载数据失败');

              case 12:
                prefix = '报告' + _this5.letterArr[i]; // 报告A

                xAxisData.push(prefix);
                data.push(chartData);

                _this5.tableCardArr.push({
                  reportId: card.reportId,
                  section: card.section
                });

              case 16:
                i++;
                _context5.next = 5;
                break;

              case 19:
                return _context5.abrupt("return", {
                  title: title,
                  id: id,
                  data: {
                    type: 'bar',
                    grid: {
                      left: '3%',
                      right: '4%',
                      bottom: '3%',
                      containLabel: true
                    },
                    title: {
                      text: title
                    },
                    xAxisData: xAxisData,
                    seriesdata: [{
                      barWidth: '30',
                      type: 'bar',
                      data: data
                    }]
                  }
                });

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    getReportPropLineData: function getReportPropLineData(reportId, pageKey, name, id) {
      var _this6 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var list, i;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!_this6.reportInfoJson[reportId] || !_this6.reportInfoJson[reportId][pageKey])) {
                  _context6.next = 3;
                  break;
                }

                _context6.next = 3;
                return _this6.loadReportPageFile(reportId, pageKey);

              case 3:
                list = _this6.reportInfoJson[reportId][pageKey][name];
                i = 0;

              case 5:
                if (!(i < list.length)) {
                  _context6.next = 11;
                  break;
                }

                if (!(list[i].id === id)) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return", list[i]);

              case 8:
                i++;
                _context6.next = 5;
                break;

              case 11:
                return _context6.abrupt("return", false);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    getReportPropData: function getReportPropData(reportId, pageKey, name, id, section) {
      var _this7 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(!_this7.reportInfoJson[reportId] || !_this7.reportInfoJson[reportId][pageKey])) {
                  _context7.next = 3;
                  break;
                }

                _context7.next = 3;
                return _this7.loadReportPageFile(reportId, pageKey);

              case 3:
                return _context7.abrupt("return", _this7.reportInfoJson[reportId][pageKey][name][id].data[section].value);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    loadReportPageFile: function loadReportPageFile(reportId, key) {
      var _this8 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var informRes, fileRes;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return (0, _report.informJSONInfo)({
                  inform_id: reportId,
                  key: key
                });

              case 2:
                informRes = _context8.sent;
                _context8.next = 5;
                return (0, _common.getFile)(informRes.data.data);

              case 5:
                fileRes = _context8.sent;
                _this8.reportInfoJson[reportId][key] = fileRes.data;
                return _context8.abrupt("return", _this8.reportInfoJson[reportId][key]);

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    loadReportPageFileJson: function loadReportPageFileJson(reportId, pageKey) {
      var _this9 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(!_this9.reportInfoJson[reportId] || !_this9.reportInfoJson[reportId][pageKey])) {
                  _context9.next = 3;
                  break;
                }

                _context9.next = 3;
                return _this9.loadReportPageFile(reportId, pageKey);

              case 3:
                return _context9.abrupt("return", _this9.reportInfoJson[reportId][pageKey]);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    tabClickHandle: function tabClickHandle() {
      this.$refs.chart.map(function (one) {
        one.resize();
      });
    },
    getReportTableSList: function getReportTableSList() {
      var _this10 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var sListData, i, json, summary, arr, j, tableData, first, _i2, cell, _j2;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                sListData = [];
                i = 0;

              case 2:
                if (!(i < _this10.cardArr.length)) {
                  _context10.next = 14;
                  break;
                }

                // { reportId: this.reportId, section: 0 }
                console.log(_this10.cardArr[i]);
                _context10.next = 6;
                return _this10.loadReportPageFileJson(_this10.cardArr[i].reportId, 's_list');

              case 6:
                json = _context10.sent;
                summary = json[_this10.cardArr[i].section].summary;
                arr = [];

                for (j = 0; j < summary.length; j++) {
                  arr = arr.concat(summary[j].summary);
                }

                sListData.push(arr);

              case 11:
                i++;
                _context10.next = 2;
                break;

              case 14:
                tableData = []; // { name, A, B, C, D, E }

                first = sListData[0];

                for (_i2 = 0; _i2 < first.length; _i2++) {
                  cell = {};
                  cell.name = first[_i2].title;

                  for (_j2 = 0; _j2 < sListData.length; _j2++) {
                    cell[_this10.letterArr[_j2]] = sListData[_j2][_i2];
                  }

                  tableData.push(cell);
                }

                console.log(tableData);
                return _context10.abrupt("return", tableData);

              case 19:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    }
  }
};
exports.default = _default;